import { MoreHoriz } from '@mui/icons-material';
import {
	Checkbox,
	IconButton,
	Menu,
	TableCell,
	TableRow,
	Typography,
	MenuItem,
	Modal,
	Box,
	Button
} from '@mui/material';
import { Image } from 'components';
import { useMenu } from 'hooks';
import { useState } from 'react';
import styled from 'styled-components';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	p: 4
};

const StyledDiv = styled('div')`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
`;

const AcademyItem = ({
	academy,
	handleClick,
	handleEditClick,
	handleDeleteClick
}) => {
	const { open, anchorEl, handleToggleMenu, closeMenu } = useMenu();
	const [isOpen, setIsOpen] = useState(false);

	const handleEditPress = (event) => {
		event.stopPropagation();
		handleEditClick(academy);
	};

	const handleDeletePress = (event) => {
		event.stopPropagation();
		closeMenu();
		setIsOpen(false);
		handleDeleteClick(academy);
	};

	const handleClose = (event) => {
		event.stopPropagation();
		closeMenu();
	};

	const handleCloseModal = (event) => {
		event.stopPropagation();
		closeMenu();
		setIsOpen(false);
	};
	const handleOpenModal = (event) => {
		event.stopPropagation();
		closeMenu();
		setIsOpen(true);
	};

	const renderMenu = () => (
		<Menu
			sx={{ zIndex: 20 }}
			open={open}
			onClose={handleClose}
			anchorEl={anchorEl}
		>
			<MenuItem onClick={handleEditPress}>Edit</MenuItem>
			<MenuItem onClick={handleOpenModal}>Delete</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(academy)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Image src={academy.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{academy.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{academy.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
			<Modal
				open={isOpen}
				onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						sx={{ textAlign: 'center' }}
					>
						Delete Academy {academy.title}
					</Typography>
					<Typography
						id="modal-modal-description"
						sx={{ mt: 2, textAlign: 'center' }}
					>
						Are you sure ?
					</Typography>
					<StyledDiv>
						<Button onClick={handleCloseModal} sx={{ color: '#000' }}>
							Cancel
						</Button>
						<Button onClick={handleDeletePress} sx={{ color: 'red' }}>
							Confirm
						</Button>
					</StyledDiv>
				</Box>
			</Modal>
		</TableRow>
	);
};

export default AcademyItem;
